import { Link } from 'react-router-dom';
import { Logo } from '@/components/brand/Logo';

/**
 * 404 — BUILD-PLAN §41/§55.
 *
 * Also what a disabled feature renders, so it must read as a normal part of
 * the site rather than an error page: a visitor who reaches a switched-off
 * module should see nothing that hints it exists.
 */
export function NotFoundPage() {
  return (
    <section className="flex min-h-[70vh] flex-col items-center justify-center px-6 py-16 text-center">
      <Logo size="md" decorative />

      <h1 className="mt-10 font-display text-3xl text-ink sm:text-4xl">
        We couldn’t find that page
      </h1>

      <p className="mt-4 max-w-md text-sm leading-relaxed text-muted">
        The page you’re looking for may have moved, or the link may no longer be correct.
      </p>

      <Link
        to="/"
        className="mt-10 inline-flex min-h-11 items-center justify-center rounded-sm border border-ink px-8 text-sm font-medium tracking-wide text-ink transition-colors hover:bg-ink hover:text-white"
      >
        Back to Home
      </Link>
    </section>
  );
}
